const remarketingTypesList = [
  '/new',
  '/new-discount',
  '/freetrial-monthly',
  '/freetrial-weekly',
  '/month-trial',
  '/fdtrial',
];

export default remarketingTypesList;
